const _excluded = ["dashboardData"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import DashCard from '@rd-web-markets/shared/dist/dashboards/components/DashCard';
import PieChart from '@rd-web-markets/shared/dist/dashboards/components/PieChart';
const ClaimGroupProjectTypesPieChart = _ref => {
  var _dashboardData$projec, _dashboardData$projec2, _dashboardData$projec3;
  let {
      dashboardData
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const labels = ['R&D', 'Non R&D', 'TBC'];
  const series = [(dashboardData === null || dashboardData === void 0 || (_dashboardData$projec = dashboardData.project_types) === null || _dashboardData$projec === void 0 ? void 0 : _dashboardData$projec.rnd) || 0, (dashboardData === null || dashboardData === void 0 || (_dashboardData$projec2 = dashboardData.project_types) === null || _dashboardData$projec2 === void 0 ? void 0 : _dashboardData$projec2.non_rnd) || 0, (dashboardData === null || dashboardData === void 0 || (_dashboardData$projec3 = dashboardData.project_types) === null || _dashboardData$projec3 === void 0 ? void 0 : _dashboardData$projec3.tbc) || 0];
  return /*#__PURE__*/React.createElement(DashCard, _extends({}, props, {
    title: "Project Category"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      height: '25px'
    }
  }), /*#__PURE__*/React.createElement(PieChart, {
    className: "pos-rel-top-10",
    labels: labels,
    series: series,
    label: 'Total Projects'
  }));
};
export default ClaimGroupProjectTypesPieChart;